export default "__VITE_ASSET__CCV3texV__"